import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allEntCarrerasAction,
  setActivoEntCarrerasAction,
} from './EntCarrerasAction';
import FormEntCarreras from './components/FormEntCarreras';
import ListadoEntCarreras from './components/ListadoEntCarreras';

const EntCarrerasView = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const entCarrerasStore = Redux.useSelector((state) => state.entCarreras);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {(loginStore.isRoot ||
          loginStore.isAdmin ||
          loginStore.isAdminTeacher) && (
          <BotonComponent
            click={async () => {
              await setActivoEntCarrerasAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            addIcon
            mr={2}
          />
        )}
        <BotonComponent
          click={async () => {
            await setActivoEntCarrerasAction(dispatch, null);
            await allEntCarrerasAction(dispatch, entCarrerasStore.params);
          }}
          disabled={
            entCarrerasStore.all.length === 0 && entCarrerasStore.loadingAll
          }
          white
          refreshIcon
          text={entCarrerasStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoEntCarreras
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </Grid>
      <ModalComponent
        id="modalFormEntCarreras"
        title={
          entCarrerasStore.activo
            ? `Editar ${entCarrerasStore.activo.carrera.nombre}`
            : 'Asignar carrera'
        }
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormEntCarreras
          activo={entCarrerasStore.activo}
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default EntCarrerasView;
